module.exports = __webpack_public_path__ + "images/videoCaseStudy-nivea-logo.png?h=6def8e88c93fbc0abf7dfff8cae7b6bc";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/nivea/videoCaseStudy-nivea-logo.png
// module id = 2113
// module chunks = 12 15